module.exports = __webpack_public_path__ + "components/flag/static/square/lu-dd3bcc25fb91f6f3ceca6b3ac99cf7da.svg";